import '@sass/pricehunter/pricehunter.scss';
import { EventDispatcher, classList, debounce, encodeFilters, fadeIn, fadeOut, getDocumentHeight, getUrlVarBase64, isEmptyObject, isMobileView, l, lLink, lc, lreplace, qs, qsa, range, showElement, urlParameterSet } from '@utils/toolbox';
import { Base64 } from '@js/plugins/base64';
import { Civet } from '@js/plugins/civet';
import { ConnectApi } from '@js/plugins/connectApi';
import { DisplayMessage } from '@js/components/displaymessage';
import { initPriceHunterMap } from '@js/components/priceHunterMap';
import noUiSlider from '@js/plugins/nouislider';
import { resultsRender } from '@js/components/resultsRender';
import { useSearchFieldMulti } from '@/src/vue/components/SearchFieldMulti/SearchFieldMulti';
import { renderPricehunterTimeline } from './timelineTemplate';


export const pricehunter = {
	selectedSorting: 'price,leavedate,datediff',
	widthToRemove: 3,
	months: js_params.module.PriceHunter.months,
	defaultIatas: js_params.module.PriceHunter.initialIatas,
	to: (js_params.module.PriceHunter.to) ? js_params.module.PriceHunter.to : [],
	from: (js_params.module.PriceHunter.from) ? js_params.module.PriceHunter.from : [],
	freeze: false,
	topbarScrollThreshold: 0,
	mouse: {
		x: 0,
		y: 0
	},

	/**
	 * @type {SearchFieldMulti}
	 */
	searchFieldMultiFrom: {},

	/**
	 * @type {SearchFieldMulti}
	 */
	searchFieldMultiTo: {},

	dateDiffMinMax: [0, 58],
	dateDiffValues_: range(1, 60),
	dateDiffValues: range(1, 60),
	priceValues_: range(js_params.module.PriceHunter.priceSliderStep, js_params.module.PriceHunter.maxPrice + js_params.module.PriceHunter.priceSliderStep, js_params.module.PriceHunter.priceSliderStep),
	priceValues: range(js_params.module.PriceHunter.priceSliderStep, js_params.module.PriceHunter.maxPrice + js_params.module.PriceHunter.priceSliderStep, js_params.module.PriceHunter.priceSliderStep),
	priceMinMax: [0, (js_params.module.PriceHunter.maxPrice / js_params.module.PriceHunter.priceSliderStep) - 1],
	serverLevel: js_params.module.PriceHunter.serverLevel,
	result: null,
	currentResult: null,
	currentFiltered: null,
	mapMode: 1,
	renderp: {
		index: 0,
		increment: 50
	},
	async init (options = {}, element = '#map') {
		this.searchFieldMultiData = reactive({
			tripType: 1,
			legs: [
				{
					fromIatas: [],
					toIatas: []
				}
			]
		});

		watch(this.searchFieldMultiData, () => {
			this.updateFilters();
		});


		this.setupSearchFields();
		this.setupSliders();
		this.setupBtns();
		this.setupTimeline();
		this.events();
		this.freeze = true;
		this.changeView();
		this.freeze = false;
		await this.setSearchParameters();


		this.search();
		this.map = await initPriceHunterMap(options, element);
		return initPriceHunterMap(options, element);
	},

	setupSearchFields () {
		const filtersTop = document.getElementById('filters-top');
		if (!filtersTop) {
			return;
		}
		const inputs = qsa('.SearchFieldMulti', filtersTop);


		this.fromField = useSearchFieldMulti({
			label: l('global.simplePhrases.From'),
			legIndex: 0,
			bound: 'from',
			data: this.searchFieldMultiData
		});
		this.fromField.mount(inputs[0]);
		this.toField = useSearchFieldMulti({
			label: l('global.simplePhrases.To'),
			legIndex: 0,
			bound: 'to',
			data: this.searchFieldMultiData
		});
		this.toField.mount(inputs[1]);
	},

	setupSliders () {
		const dateSlider = document.getElementById('dateDiffSlider');
		const priceSlider = document.getElementById('priceSlider');

		if (!dateSlider || !priceSlider) {
			return;
		}

		this.dateDiffSlider = dateSlider;
		this.priceSlider = priceSlider;

		noUiSlider.create(this.dateDiffSlider, {
			start: [0, 100],
			range: {
				min: [this.dateDiffMinMax[0]],
				max: [this.dateDiffMinMax[1]]
			},

			connect: [false, true, false]
		});

		noUiSlider.create(this.priceSlider, {
			start: this.priceMinMax[1],
			range: {
				min: [this.priceMinMax[0]],
				max: [this.priceMinMax[1]]
			},

			connect: 'lower'
		});

		this.dateDiffSlider.classList.add('noUi-themed');
		this.priceSlider.classList.add('noUi-themed');
	},

	setupBtns () {
		EventDispatcher.addEventListener('toggleMap', (mapMode) => {
			qs('#spinner').classList.remove('spinner--hidden');
			this.toggleShowIata();
			this.mapMode = mapMode;
			this.changeView();
			this.search();
		});

		// qs('#days')?.addEventListener('change', pricehunter.updateFilters);

		document.addEventListener('click', (event) => {
			const element = event.target;

			if (element.closest('.abBtnCard--switchMapCalendar')) {
				EventDispatcher.dispatch('toggleMap', element.closest('.abBtnCard').classList.contains('switched'));

				if (element.closest('.abBtnCard').classList.contains('switched')) {
					element.closest('.abBtnCard').classList.remove('switched');
					// Map view
				} else {
					element.closest('.abBtnCard').classList.add('switched');
					// Calendar view
				}
			}

			if (element.closest('.abTabNav--priceWatcherChooseMonth')) {
				if (qs('.abTabNav--priceWatcherChooseMonth .active')) {
					qs('.abTabNav--priceWatcherChooseMonth .active').classList.remove('active');
				}

				element.closest('.abTabNav__btn').classList.add('active');

				this.changeView();
				this.updateFilters();
			}

			if (element.closest('.abTabNav--priceWatcherSortMonth')) {
				const elementBtn = element.closest('.abTabNav__btn');

				if (!elementBtn.classList.contains('active')) {
					if (qs('.abTabNav--priceWatcherSortMonth .active')) {
						qs('.abTabNav--priceWatcherSortMonth .active').classList.remove('active');
					}

					element.closest('.abTabNav__btn').classList.add('active');

					switch (elementBtn.closest('.abTabNav__btn').dataset.value) {
						case 'outbound-date':
							this.selectedSorting = 'leavedate,price,datediff';
							break;
						case 'price':
							this.selectedSorting = 'price,leavedate,datediff';
							break;
						case 'trip-length':
							this.selectedSorting = 'datediff,price,leavedate';
							break;
					}

					this.updateFilters();
				}
			}
		});
	},

	setupTimeline () {
		const activeTimelinePopup = null;
		const timeline = qs('#timeline');

		if (!timeline) {
			return;
		}

		timeline.addEventListener('click', async (e) => {
			if (!e.target.closest('.timeline-container')) {
				return;
			}
			const target = e.target.closest('.timeline-data-canvas-cells-rows-row-bar');
			const row = this.dataForElement(target);
			const { response_id: id } = row;
			const response = await ConnectApi('Lastminute', 'getFlightByHash', [id, 0]);

			resultsRender.setData(response);
			const flight = resultsRender.response.flights[0];
			resultsRender.renderModal(id, flight, 0, {}, { className: 'modal--resultModal' }, {}, 'lastminute', 'price').open();
		});
	},

	getShowresultUrl (row) {
		const isDirectFlightsOnly = this.getFilters().isDirectFlightsOnly;
		const filters = isDirectFlightsOnly ? encodeFilters({ numStops: 0 }) : false;
		const queryParams = new URLSearchParams({
			id: row.response_id,
			sorting: 'price'
		});
		if (filters) {
			queryParams.append('filter', filters);
		}
		return `/${lLink('global.navigation.resultsLink')}?${queryParams.toString()}`;
	},

	events () {
		const filtersTop = document.getElementById('filters-top');
		if (!filtersTop) {
			return;
		}
		window.addEventListener('scroll', debounce(() => {
			if (this.mapMode || !this.getSelectedYearMonth()) {
				return;
			}

			const docHeight = getDocumentHeight();
			const docScroll = document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop;

			const diff = docHeight - docScroll;

			if (diff < 2000) {
				this.render(this.currentFiltered);
			}
		}, 150));


		// slider events

		this.dateDiffSlider.noUiSlider.on('update', (values) => {
			const daysMin = this.dateDiffValues[Math.round(values[0])];
			const daysMax = this.dateDiffValues[Math.round(values[1])];
			const text = lreplace('pricehunter.form.tripSpan', {
				daysMin: daysMin,
				daysMax: daysMax
			});

			document.getElementById('dateDiffValue').innerText = text;
		});

		this.dateDiffSlider.noUiSlider.on('set', () => {
			if (!this.freezeSliders) {
				this.updateFilters();
			}
		});

		this.priceSlider.noUiSlider.on('update', (values) => {
			const priceMax = this.priceValues[Math.round(values[0])];
			const text = lreplace('pricehunter.form.priceDesc', {
				price: lc(priceMax)
			});

			document.getElementById('priceValue').innerText = text;
		});

		this.priceSlider.noUiSlider.on('set', () => {
			if (!this.freezeSliders) {
				this.updateFilters();
			}
		});

		document.addEventListener('click', (e) => {
			const elem = e.target;

			if (elem.closest('[data-action="filters-clear"')) {
				this.resetFilters();
				return;
			}

			if (elem.matches('[data-action="filter-direct"]')) {
				e.stopPropagation();
				this.updateFilters();
				return;
			}

			if (elem.closest('[data-remove-iata]')) {
				e.preventDefault();

				this.removeIataSelection(elem.closest('[data-remove-iata]'));

				return;
			}

			if (elem.closest('#calendar')) {
				const selectedMonth = elem.closest('.abCard');
				const yearMonth = selectedMonth.querySelector('.abCard--content').dataset.yearmonth;
				const monthList = document.querySelectorAll('.abWrapper .abTabNav__btn');
				const selected = [...monthList].filter(month => month.dataset.value === yearMonth)[0];

				// Remove active class from all items
				monthList.forEach(col => col.classList.remove('active'));

				if (selected) {
					selected.classList.add('active');
				}

				// Now switch view to month
				this.updateFilters();

				document.getElementById('spinner').classList.remove('spinner--hidden');

				setTimeout(() => this.changeView(), 200);
			}
		}, false);


		// Ugly workaround, proxying the select change event to the tab click event
		qs('.menu-primary .select').addEventListener('change', (e) => {
			let value = e.target.options[e.target.selectedIndex].dataset.value;
			if (value === undefined) {
				value = 'alla';
			}
			qs('.abTabNav__btn[data-value="' + value + '"]').click();
		});

		document.addEventListener('mousemove', (e) => {
			this.mouse.x = e.pageX;
			this.mouse.y = e.pageY;
		}, false);
	},

	resetSliders () {
		this.freezeSliders = true;

		this.dateDiffValues = this.dateDiffValues_;
		this.dateDiffSlider.noUiSlider.set([
			this.dateDiffMinMax[0],
			this.dateDiffMinMax[1]
		]);

		this.priceValues = this.priceValues_;
		this.priceSlider.noUiSlider.set([
			this.priceMinMax[1]
		]);

		this.freezeSliders = false;
	},

	inServerMode () {
		return true;
	},

	inCalendarMode () {
		const modeOn = !this.mapMode && qs('.abWrapper .abTabNav__btn').classList.contains('active');

		// to-do
		if (modeOn) {
			qs('.view-type li')?.classList?.remove('active');
			qsa('.view-type li')?.[1]?.classList?.add('active');
		}

		return modeOn;
	},

	updateFilters () {
		qs('#spinner').classList.remove('spinner--hidden');

		qs('#timeline-container').innerHTML = '';

		this.search();
	},

	checkCities (elem) {
		const country = elem.closets('div.country');

		if (country.querySelector('input.city:not(:checked)').size() > 0) {
			country.querySelector('input.country').checked = false;
		} else {
			country.querySelector('input.country').checked = true;
		}
	},

	dataForElement (element) {
		const index = parseInt(element.dataset.index);
		const row = this.currentFiltered[index];

		return row;
	},

	getSelectedYearMonth () {
		let month = qs('.abTabNav--priceWatcherChooseMonth .active')?.dataset?.value;

		if (typeof month === 'undefined' || month === 'alla') {
			return false;
		}

		month = month.split('-');

		if (month.length >= 2) {
			const year = parseInt(month[0], 10);
			month = parseInt(month[1], 10);

			return { year: year, month: month };
		}

		const defaultDate = new Date();
		return { year: defaultDate.getFullYear(), month: defaultDate.getMonth() + 1 };
	},

	getSelectedSorting () {
		return this.selectedSorting;
	},

	async setSearchParameters () {
		// Get search parameters from URL
		const searchParameters = getUrlVarBase64('searchParameters');

		if (isEmptyObject(searchParameters)) {
			return;
		}

		// Update sliders
		const priceIndex = this.priceValues.indexOf(parseInt(searchParameters.priceMax, 10));
		this.priceSlider.noUiSlider.set(priceIndex, false);

		this.dateDiffSlider.noUiSlider.set([searchParameters.travellength_min - 1, searchParameters.travellength_max - 1], false);

		// Update search fields
		const initSearchFieldMulti = async (urlIata, property) => {
			if (!urlIata?.length) {
				return;
			}

			const response = await ConnectApi('IataAutocomplete', 'searchByIatas', [urlIata]);

			const checkedIatas = response.flatMap((item) => {
				if (item.type === 'metro') {
					return item.children.map(child => ({
						iata: child.iata,
						text: child.airport,
						isMetro: false
					}));
				}
				return {
					iata: item.iata,
					text: item.airport,
					isMetro: false
				};
			});

			// searchFieldMulti.checkedIatas = checkedIatas;
			this.searchFieldMultiData.legs[0][property] = checkedIatas;
		};

		let initPromise1 = Promise.resolve();
		if (JSON.stringify(searchParameters.iatas_from) !== JSON.stringify(this.defaultIatas)) {
			initPromise1 = initSearchFieldMulti(searchParameters?.iatas_from, 'fromIatas');
		}
		const initPromise2 = initSearchFieldMulti(searchParameters?.iatas_to, 'toIatas');

		await Promise.all([initPromise1, initPromise2]);

		// Update month select
		const selected = qsa('.abTabNav--priceWatcherChooseMonth .abTabNav__btn').find(month => month.dataset.value === [searchParameters.year, searchParameters.month].join('-'));
		if (selected) {
			// Remove active class from all items
			qs('.abTabNav--priceWatcherChooseMonth .active').classList.remove('active');

			// Add active class to selected item
			selected.classList.add('active');

			// Update select element
			qs('.menu-primary .select').value = searchParameters.month;
		}

		// Update direct
		qs('#directFlights').checked = searchParameters.directFlights;
	},

	getSearchParameters (optn) {
		const options = optn ? optn : false;

		const yearMonth = this.getSelectedYearMonth();

		const from = this.searchFieldMultiData.legs[0].fromIatas.map(item => item.iata);
		const to = this.searchFieldMultiData.legs[0].toIatas.map(item => item.iata);

		let data = {
			iatas_from: from.length ? from : this.defaultIatas,
			iatas_to: to.length ? to : [],
			sort: this.inServerMode() ? this.getSelectedSorting() : '',
			map: this.mapMode
		};

		data.filter_iatas_from = data.iatas_from;

		if (yearMonth) {
			Object.assign(data, { year: yearMonth.year, month: yearMonth.month });
		}

		if (this.inCalendarMode() && yearMonth === false) {
			Object.assign(data, { group_by: 'month', sort: 'r.leavedate,r.price,datediff' });
		}

		if (this.inCalendarMode()) {
			Object.assign(data, { calendar: true });
		}

		if (this.inServerMode()) {
			let priceMax = parseInt(this?.priceSlider?.noUiSlider?.get?.(), 10) || this.priceValues.length - 1;
			priceMax = this.priceValues[Math.round(priceMax)];

			Object.assign(data, { priceMax });
		}

		if (this.dateDiffValues && this.inServerMode() && this?.dateDiffSlider?.noUiSlider?.get) {
			const dateDiff = this?.dateDiffSlider?.noUiSlider?.get().map(v => Math.round(v));
			const dateDiffMin = this.dateDiffValues[dateDiff[0]];
			const dateDiffMax = this.dateDiffValues[dateDiff[1]];

			data = Object.assign(data, { travellength_min: dateDiffMin, travellength_max: dateDiffMax });
		} else {
			data = Object.assign(data, { travellength_min: 1, travellength_max: 59 });
		}

		// Direct flights only
		const directFlights = qs('#directFlights')?.checked ?? false;
		data = Object.assign(data, { directFlights });

		if (options) {
			data = Object.assign(data, options);
		} else if (document.body.classList.contains('prisjagaren')) {
			// Write parameters to URL
			const dataBase64 = Base64.encode(JSON.stringify(data));
			urlParameterSet('searchParameters', dataBase64);
		}


		return data;
	},

	showDisplayMessage (config = {}) {
		config = {
			style: 'inline',
			messageText: l('error.e14'),
			buttonText: l('error-page.message.goback'),
			callBack: () => this.displayMessage.hide(),
			...config
		};
		if (typeof this.displayMessage === 'undefined') {
			this.displayMessage = new DisplayMessage(document.body, config);
			this.displayMessage.show();
		} else {
			this.displayMessage.update(config);
			this.displayMessage.show();
		}
	},

	search () {
		if (document.body.classList.contains('modal-open')) {
			qs('#close-modal').innerHTML = l('showresult.filter.apply');
		}
		this.clearList();

		const data = this.getSearchParameters();
		fadeOut('.summary__cheapest');
		isMobileView() && fadeIn('#summary-spinner');
		fadeOut('.map-container .noResults');
		this.response?.abort?.();
		this.response = ConnectApi('PriceHunter', 'get', [data]).then(async (response) => {
			await fadeOut('#summary-spinner');
			if (!response?.rows) {
				return;
			}

			const { rows } = response;
			this.setPossibleSliderValues(rows);

			this.result = { price: response.rows };

			this.filtered = this.filter(response.rows);

			if (this.filtered.length === 0) {
				showElement('.map-container .noResults');
			}

			if (this.mapMode) {
				EventDispatcher.dispatch('pricehunterMapDataFetched', this.filtered);
			} else {
				if (this.getSelectedYearMonth()) {
					this.render(this.filtered);
				} else {
					this.renderCalendar(this.filtered);
				}
			}
			classList('#spinner').add('spinner--hidden');
		}).catch((error) => {
			// this.showDisplayMessage();
			// toaster.newToast(l('error.e14'), 'error', 'top');


			classList('#spinner').add('spinner--hidden');

			Civet.reportError(error);
		});
	},

	setPossibleSliderValues (rows) {
		this.freezeSliders = true;

		const sliders = [
			{
				slider: this.dateDiffSlider,
				valuesName: 'dateDiffSlider',
				prop: 'datediff'
			},

			{
				slider: this.priceSlider,
				valuesName: 'priceValues',
				prop: 'price'
			}
		];

		sliders.forEach((value, index) => {
			if (!value?.slider?.noUiSlider?.get) {
				return;
			}

			if (value.slider.noUiSlider.get().length === 2) {
				const values = value.slider.noUiSlider.get();
				value.slider.noUiSlider.set(values);
			} else {
				const _value = value.slider.noUiSlider.get();
				value.slider.noUiSlider.set(_value);
			}
		});

		this.freezeSliders = false;
	},

	sort (rows) {
		if (this.mapMode || !this.getSelectedYearMonth()) {
			return rows;
		}

		return rows;
	},

	getFilters () {
		const dateValues = this.dateDiffSlider?.noUiSlider?.get?.()?.map?.(v => Math.round(v)) || [0, 58];
		const priceValue = Math.round(this.priceSlider?.noUiSlider?.get?.() || 0) || this.priceValues.length - 1;

		const days = [
			this.dateDiffValues[dateValues[0]],
			this.dateDiffValues[dateValues[1]]
		];
		return {
			isDirectFlightsOnly: qs('#directFlights')?.checked || false,
			price: this.priceValues[priceValue],
			days: days
		};
	},

	getFilteredResults (rows) {
		const filters = this.getFilters();
		const returnRows = rows.filter((row) => {
			if (row.datediff < filters.days[0] || row.datediff > filters.days[1]) {
				return false;
			}
			if (row.price > filters.price) {
				return false;
			}
			if (filters.isDirectFlightsOnly) {
				if (row.direct_flight_price === -1) {
					return false;
				}
				row.price = row.direct_flight_price;
			}
			return true;
		});
		return returnRows;
	},

	resetFilters () {
		this.resetSliders();
		qs('#directFlights').checked = false;
		qsa('.select').forEach(select => (select.value = -1));
		qs('.abTabNav--priceWatcherChooseMonth .abTabNav__btn').classList.add('active');
		this.updateFilters();
	},

	filter (rows) {
		this.clearList();
		const result = this.getFilteredResults(rows);

		// unknown delay required...
		setTimeout(() => (this.currentFiltered = result), 500);

		return result;
	},

	clearList () {
		this.renderp.index = 0;

		setTimeout(() => {
			const prices = qs('#prices');
			const flights = qs('#flights');
			const days = qs('#days');
			if (prices) {
				prices.innerHTML = '';
			}
			if (flights) {
				flights.innerHTML = '';
			}
			if (days) {
				days.innerHTML = '';
			}
		}, 100);
	},

	render (rows) {
		const upperSlice = this.renderp.index + this.renderp.increment;

		const newRows = [];

		let i = this.renderp.index;

		for (; i < upperSlice && i < rows.length; ++i) {
			newRows.push({ idx: i, ...rows[i] });
		}

		if (newRows.length === 0) {
			return;
		}

		this.renderp.index = i;


		const html = renderPricehunterTimeline(this.getCalendarData(), newRows, this.widthPerDay);

		qs('#timeline-container')?.insertAdjacentHTML?.('beforeend', html);
	},

	renderCalendar (data) {
		const html = ['<div class="abWrapper warpedWrapper">'];

		for (let i = 0; i < data.length; ++i) {
			const row = data[i];

			const date = row.leavedate.split('-');
			let month = parseInt(date[1], 10) - 1;
			const year = date[0];
			month = this.months[month];

			html.push('<div class="abCard">');
			html.push('<span class="abCard--title">' + row.tocity + ', ' + month + ' ' + year + '</span>');
			html.push('<span class="abCard--content deal" data-yearmonth=' + [date[0], parseInt(date[1], 10)].join('-') + '>' + l('global.simplePhrases.From') + ' ' + lc(row.price) + '</span>');
			html.push('</div>');
		}

		html.push('</div>');

		qs('#calendar').innerHTML = html.join('');
	},

	getCalendarData () {
		const selectedDate = this.getSelectedYearMonth();

		const monthYear = this.months[selectedDate.month - 1] + ' ' + selectedDate.year;

		const days = daysInMonth(selectedDate.month, selectedDate.year);

		const daysArr = [];

		for (let i = 1; i <= days; ++i) {
			daysArr.push(i);
		}

		this.widthPerDay = 100 / daysArr.length;
		const dayWidth = 100 / daysArr[daysArr.length - 1];

		const data = {
			days: daysArr,
			dayWidth: dayWidth,
			month: monthYear
		};

		return data;
	},

	showFlightInfo (row) {
		let html = [];

		let leavedate = row.leavedate.split('-');
		let homedate = row.homedate.split('-');

		leavedate = new Date(parseInt(leavedate[0], 10), parseInt(leavedate[1], 10) - 1, parseInt(leavedate[2], 10));
		homedate = new Date(parseInt(homedate[0], 10), parseInt(homedate[1], 10) - 1, parseInt(homedate[2], 10));

		const months = monthsBetween(leavedate, homedate);
		const width = 100 / months.length;

		const info = qs('#flight-info');

		info.querySelector('span.outbound-date').innerText = row.leavedate;
		info.querySelector('span.inbound-date').innerText = row.homedate;

		info.querySelector('span.from').innerText = row.localizedfromcity + ', ' + row.outbound_from;
		info.querySelector('span.to').innerText = row.localizedtocity + ', ' + row.outbound_to;

		info.querySelector('span.price').innerHTML = (lc(row.price));

		info.querySelector('span.trip-duration').innerText = row.datediff;
		info.querySelector('.search-text').innerText = 'Sökningen gjordes för $timetext sedan'.replace('$timetext', strTime(row.searchtimestamp));

		html = [
			`<table>
				<tbody>
					<tr>
			`
		];

		for (let i = 0; i < months.length; ++i) {
			html.push(`
				<td class="month" style="width: ${width}%;">
					${this.months[months[i]]}
				</td>`
			);
		}

		html.push(`</tr><tr class="bar-container">`);

		for (let i = 0; i < months.length; ++i) {
			let style = [];
			let _width = 100;
			let daysMonth;

			// This is first, displace using margin-left
			if (i === 0) {
				daysMonth = daysInMonth(leavedate.getMonth() + 1, leavedate.getFullYear());
				const margin = (leavedate.getDate() - 1) / daysMonth * 100;

				style.push('margin-left: ' + margin + '%;');

				if (i === months.length - 1) {
					_width = (row.datediff + 1) / daysMonth * 100;
				}
			} else if (i === months.length - 1) { // This is last, add finite width
				daysMonth = daysInMonth(homedate.getMonth() + 1, homedate.getFullYear());

				_width = (homedate.getDate() + 1) / daysMonth * 100;
			}

			daysMonth = daysInMonth(homedate.getMonth() + 1, homedate.getFullYear());

			if (homedate.getDate() === daysMonth) {
				_width = 100;
			}

			style.push('width: ' + _width + '%;');
			style = style.join(' ');

			html.push(`
				<td style="width: ${width}%;">
					<div style="overflow:hidden">
						<div class="flight-info-bar" style="${style}">&nbsp;</div>
					</div>
				</td>
			`);
		}

		html.push(`
					</tr>
				</tbody>
			</table>
		`);

		html = html.join('');

		info.querySelector('.range').innerHTML = html;

		fadeIn(info);

		return info;
	},

	toggleShowIata () {
		setTimeout(() => {
			this.clearList();
			this.render(this.currentFiltered);
		}, 1);
	},

	changeView () {
		this.currentFiltered = [];

		const calendar = document.getElementById('calendar');

		// Map view
		if (this.mapMode) {
			const topList = document.getElementsByClassName('topListArea')[0];
			const flightList = document.getElementById('flightList');

			if (topList) {
				topList.classList.remove('fixed');
			}

			if (flightList) {
				flightList.getElementsByTagName('li')[0].classList.remove('fixed');
			}

			if (calendar) {
				calendar.innerHTML = '';
			}

			document.body.classList.remove('show-calendar', 'display-timeline');

			EventDispatcher.dispatch('mapToggleComplete');
		} else {
			// Calendar
			if (this.inCalendarMode()) {
				document.body.classList.add('show-calendar');
				document.body.classList.remove('display-timeline');
			} else {
				if (calendar) {
					calendar.innerHTML = '';
				}

				document.body.classList.remove('show-calendar');
				document.body.classList.add('display-timeline');
			}
		}
	}
};

// -----------------------------------------------------
// -----------------------------------------------------
// --- END OF pricehunter ------------------------------
// -----------------------------------------------------
// -----------------------------------------------------


function monthsBetween (d1, d2) {
	const result = [];

	let date = new Date(d1.getFullYear(), d1.getMonth());

	while (date.getTime() <= d2.getTime()) {
		result.push(date.getMonth());

		date = new Date(date.getFullYear(), date.getMonth() + 1);
	}

	return result;
}

function daysInMonth (month, year) {
	return new Date(year, month, 0).getDate();
}

function strTime (searchtimestamp) {
	const diff = Math.round(new Date().getTime() / 1000) - parseInt(searchtimestamp);

	const days = Math.floor(diff / (60 * 60 * 24));
	const hours = Math.floor((diff - days * 60 * 60 * 24) / (60 * 60));
	const minutes = Math.floor((diff - days * 60 * 60 * 24 - hours * 60 * 60) / 60);

	if (days < 1 && minutes < 1 && hours < 1) {
		return l('global.time.zeroMinutes');
	}

	let resultString = '';

	if (days > 0) {
		resultString += days > 1 ? lreplace('global.simplePhrases.numberOfDays', { num: days }) : l('global.time.oneDay');
	}

	if (hours > 0) {
		if (days > 0 && minutes > 0) {
			resultString += ',';
		} else if (days > 0) {
			resultString += ' ' + l('global.simplePhrases.and');
		}

		resultString += hours > 1 ? ' ' + lreplace('global.simplePhrases.numberOfHours', { num: hours }) : ' ' + l('global.time.oneHour');
	}

	if (minutes > 0) {
		if (days > 0 || hours > 0) {
			resultString += ' ' + l('global.simplePhrases.and');
		}

		resultString += minutes > 1 ? ' ' + lreplace('global.simplePhrases.numberOfMinutes', { num: minutes }) : ' ' + l('global.time.oneMinute');
	}

	return resultString;
}
window.pricehunter = pricehunter;
